/*global global */
const observe = jest.fn();
const mutationObserverMock = jest.fn(function MutationObserver() {
    this.observe = observe;
    this.disconnect = jest.fn();
});
// @ts-ignore
global.MutationObserver = mutationObserverMock;
import waitForHydrated from "./waitForHydrated";
import { JSDOM } from "jsdom";

describe("waitForHydrated", () => {
    it("calls the callback immediately when it already is hydrated", () => {
        const callback = jest.fn();
        const dom = new JSDOM("<div class='hydrated'></div>");
        const element = dom.window.document.querySelector("div");
        waitForHydrated(element, callback);
        expect(callback).toHaveBeenCalled();
    });

    it("sets up a mutation observer when no hydrated class is present", () => {
        expect.assertions(2);
        const callback = jest.fn();
        const dom = new JSDOM("<div></div>");
        const element = dom.window.document.querySelector("div");
        waitForHydrated(element, callback);
        expect(callback).toHaveBeenCalledTimes(0);
        expect(observe).toHaveBeenCalledTimes(1);
        // sadly there was no apparent solution to test the outcome of the mutationObserver with JSDOM
    });
});
